//
//
//
//
//
//
//
//
//
//
//
//

import Cropper from 'cropperjs'

export default {
  components: {},
  data () {
    return {
      headerImage: '',
      cropper: '',
      croppable: false,
    }
  },
  props: {
    picValue: String,
    panel: Boolean,
    url: String
  },
  mounted () {
    //初始化这个裁剪框
    var self = this
    var image = document.getElementById('image')
    this.cropper = new Cropper(image, {
      // aspectRatio: 16/9, //可指定裁剪框的长宽比
      viewMode: 1,
      background: false,
      zoomable: false,
      ready: function () {
        self.croppable = true
      }
    })
  },
  methods: {
    crop () {
      var croppedCanvas
      var roundedCanvas
      this.$emit('handleShow', false)
      if (!this.croppable) {
        return
      }
      // Crop
      croppedCanvas = this.cropper.getCroppedCanvas()
      // Round
      roundedCanvas = this.getRoundedCanvas(croppedCanvas)
      this.headerImage = roundedCanvas.toDataURL()
      this.$emit('handleGetUrl', this.headerImage)
      this.$emit('upload')
    },
    getRoundedCanvas (sourceCanvas) {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      var width = sourceCanvas.width
      var height = sourceCanvas.height
      canvas.width = width
      canvas.height = height
      context.imageSmoothingEnabled = true
      context.drawImage(sourceCanvas, 0, 0, width, height)
      context.globalCompositeOperation = 'destination-in'
      context.beginPath()
      // context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
      context.fill()
      return canvas
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/uiCrop.vue